// extracted by mini-css-extract-plugin
export default {"coupon":"DetailPage_coupon__Cnaxz"};